const HOUR_SECONDS = 3600;

/** Horloge lecture : `mm:ss` si &lt; 1 h, sinon `h:mm:ss` (ex. `05:07`, `1:02:30`). */
export function formatPodcastClock(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '00:00';
  const sec = Math.floor(seconds);
  if (sec >= HOUR_SECONDS) {
    const h = Math.floor(sec / HOUR_SECONDS);
    const m = Math.floor((sec % HOUR_SECONDS) / 60);
    const s = sec % 60;
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** Durée lisible avec unité (`45 min`, `2 h 43 min`). */
export function formatPodcastDurationWithUnit(
  seconds: number,
  options?: { includeSeconds?: boolean },
): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '—';
  const sec = Math.floor(seconds);
  const includeSeconds = options?.includeSeconds ?? false;

  if (sec >= HOUR_SECONDS) {
    const h = Math.floor(sec / HOUR_SECONDS);
    const m = Math.floor((sec % HOUR_SECONDS) / 60);
    const s = sec % 60;
    if (m === 0 && (!includeSeconds || s === 0)) return `${h} h`;
    if (!includeSeconds || s === 0) return `${h} h ${m} min`;
    return `${h} h ${m} min ${s} s`;
  }

  const m = Math.floor(sec / 60);
  const s = sec % 60;
  if (m === 0) return `${s} s`;
  if (!includeSeconds || s === 0) return `${m} min`;
  return `${m} min ${s} s`;
}
